import React from 'react';
import PropTypes from 'prop-types';
import './Checkbox.scss';

/**
 * Controlled checkbox component
 * @class Checkbox
 * @extends {Component}
 */
class Checkbox extends React.Component {
  static propTypes = {
    /** Whether the checkbox should be checked */
    checked: PropTypes.bool,
    /** Callback called when the checkbox is clicked */
    onClick: PropTypes.func.isRequired,
    /** The text on the label for the checkbox */
    label: PropTypes.string,
  };

  static defaultProps = {
    checked: false,
    onClick: () => null,
    label: 'Remember Me',
  };

  render() {
    return (
      <div className='checkbox'>
        <label>
          <input type='checkbox' defaultChecked={this.props.checked} onClick={this.props.onClick}/>
          { this.props.label }
        </label>
      </div>
    );
  }
}

export default Checkbox;
